import React, { useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';

const Header = ({ selectedPublisher, onPublisherChange, publishers, darkMode = false }) => {
  const headerRef = useRef(null);

  useEffect(() => {
    // Set CSS variable for header height so CategoryTabs can position correctly
    if (headerRef.current) {
      const height = headerRef.current.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }
  }, []);

  return (
    <header ref={headerRef} className={`sticky top-0 z-50 border-b ${darkMode ? 'bg-gray-900 border-gray-700' : 'bg-white border-gray-200'}`}>
      {/* Safe area padding for mobile status bar */}
      <div className="pt-[env(safe-area-inset-top,12px)]" />
      <div className="px-4 py-3">
        {/* Logo and Status Bar */}
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <h1 className="text-2xl font-bold">
              <span className={darkMode ? 'text-white' : 'text-gray-900'}>Smart</span>
              <span className="text-orange-500">ReadGo</span>
            </h1>
          </div>
          {/* Status icons would go here - keeping it simple for now */}
        </div>

        {/* Today's Highlights and Publisher Filter */}
        <div className="flex items-center justify-between gap-3">
          <h2 className={`text-xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>Today's Highlights</h2>
          
          <Select value={selectedPublisher} onValueChange={onPublisherChange}>
            <SelectTrigger className={`w-[200px] ${darkMode ? 'border-gray-600 bg-gray-800 text-white' : 'border-gray-300'}`}>
              <SelectValue placeholder="All News Sources" />
            </SelectTrigger>
            <SelectContent className={darkMode ? 'bg-gray-800 border-gray-700' : ''}>
              {publishers.map((publisher) => (
                <SelectItem key={publisher.id} value={publisher.id} className={darkMode ? 'text-white focus:bg-gray-700' : ''}>
                  {publisher.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </header>
  );
};

export default Header;